import { render, staticRenderFns } from "./SearchNavItemTartgets.vue?vue&type=template&id=49ffd33f&scoped=true"
import script from "./SearchNavItemTartgets.vue?vue&type=script&lang=js"
export * from "./SearchNavItemTartgets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ffd33f",
  null
  
)

export default component.exports